import axios from "../../../../helper/axios";
import * as actionTypes from "../../actionTypes";

// select project from update section
export const MilestonePrecent = (calc) => {
  return {
    type: actionTypes.MILESTONE_PERCENT,
    calc,
  };
};

// fetch milestons
export const fetchProjectMilestonesStart = () => {
  return {
    type: actionTypes.FETCH_PROJECT_MILESTONES_START,
  };
};

export const fetchProjectMilestonesSuccess = (
  milestones,
  count,
  totalOfDone,
  percentage
) => {
  return {
    type: actionTypes.FETCH_PROJECT_MILESTONES_SUCCESS,
    milestones,
    count,
    totalOfDone,
    percentage,
  };
};

export const fetchProjectMilestonesFail = (error) => {
  return {
    type: actionTypes.FETCH_PROJECT_MILESTONES_FAIL,
    error,
  };
};

export const fetchProjectMilestones = (projectId, pageN, pageS) => {
  return (dispatch) => {
    dispatch(fetchProjectMilestonesStart());
    axios
      .get(`client/task/${projectId}?pageNumber=${pageN}&pageSize=${pageS}`)
      .then((res) => {
        // console.log(res);
        dispatch(
          fetchProjectMilestonesSuccess(
            res.data.tasks,
            res.data.total,
            res.data.totalDone,
            Math.floor((res.data.totalDone / res.data.total) * 100)
          )
        );
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchProjectMilestonesFail(err.response.data.message));
        } else {
          dispatch(fetchProjectMilestonesFail("Something went wrong"));
        }
      });
  };
};

// Create milestone for project
export const createProjectMilestoneStart = () => {
  return {
    type: actionTypes.CREATE_PROJECT_MILESTONE_START,
  };
};

export const createProjectMilestoneSuccess = (newMilestone, msg) => {
  return {
    type: actionTypes.CREATE_PROJECT_MILESTONE_SUCCESS,
    newMilestone,
    msg,
  };
};

export const createProjectMilestoneFail = (error) => {
  return {
    type: actionTypes.CREATE_PROJECT_MILESTONE_FAIL,
    error,
  };
};

export const SelectProjectId = (projectId) => {
  return {
    type: actionTypes.SELECT_PROJECT_ID,
    projectId: projectId,
  };
};
export const clearProjectId = () => {
  return {
    type: actionTypes.CLEAR_PROJECT_ID,
  };
};

export const createProjectMilestone = (projectId, data, callBack) => {
  return (dispatch) => {
    dispatch(createProjectMilestoneStart());

    axios
      .post(`admin/client/task/${projectId}`, data)
      .then((res) => {
        console.log(res);
        dispatch(
          createProjectMilestoneSuccess(
            {
              ts_id: res.data.task.taskId,
              done: res.data.task.doneState,
              name: data.name,
              description: data.description,
            },
            res.data.message
          )
        );
        callBack();
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(createProjectMilestoneFail(err.response.data.message));
        } else {
          dispatch(createProjectMilestoneFail("Something went wrong"));
        }
      });
  };
};

// DELETE Mileston
export const deleteProjectMilestoneStart = () => {
  return {
    type: actionTypes.DELETE_PROJECT_MILESTONE_START,
  };
};

export const deleteProjectMilestoneSuccess = (milestoneId, msg) => {
  return {
    type: actionTypes.DELETE_PROJECT_MILESTONE_SUCCESS,
    milestoneId,
    msg,
  };
};
export const deleteProjectMilestoneFail = (error) => {
  return {
    type: actionTypes.DELETE_PROJECT_MILESTONE_FAIL,
    error,
  };
};

export const deleteProjectMilestone = (milestoneId) => {
  return (dispatch) => {
    dispatch(deleteProjectMilestoneStart());
    axios
      .delete(`api/v1/admin/client/milestone/${milestoneId}`)
      .then((res) => {
        // console.log(res);
        // console.log(milestoneId);
        dispatch(
          deleteProjectMilestoneSuccess(milestoneId, "MILESTONE DELETED")
        );
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(deleteProjectMilestoneFail(err.response.data.message));
        } else {
          dispatch(deleteProjectMilestoneFail("Something went wrong"));
        }
      });
  };
};

// Update status Mileston
export const updateStatusMilestoneStart = () => {
  return {
    type: actionTypes.UPDATE_STATUS_PROJECT_MILESTONE_START,
  };
};

export const updateStatusMilestoneSuccess = (milestoneId, status, msg) => {
  return {
    type: actionTypes.UPDATE_STATUS_PROJECT_MILESTONE_SUCCESS,
    milestoneId,
    status,
    msg,
  };
};
export const updateStatusMilestoneFail = (error) => {
  return {
    type: actionTypes.UPDATE_STATUS_PROJECT_MILESTONE_FAIL,
    error,
  };
};

export const updateStatusMilestone = (milestoneId, data) => {
  return (dispatch) => {
    // console.log(data);
    dispatch(updateStatusMilestoneStart());
    axios
      .patch(`api/v1/admin/client/milestone/${milestoneId}`, data)
      .then((res) => {
        // console.log(res);
        // console.log(milestoneId);
        dispatch(
          updateStatusMilestoneSuccess(
            milestoneId,
            data.status,
            "MILESTONE UPDATED"
          )
        );
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(updateStatusMilestoneFail(err.response.data.message));
        } else {
          dispatch(updateStatusMilestoneFail("Something went wrong"));
        }
      });
  };
};

// fetch projects
export const fetchClientProjectsForMilestonStart = () => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECTS_FOR_MILESTONE_START,
  };
};

export const fetchClientProjectsForMilestonSuccess = (projects) => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECTS_FOR_MILESTONE_SUCCESS,
    projects,
  };
};

export const fetchClientProjectsForMilestonFail = (error) => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECTS_FOR_MILESTONE_FAIL,
    error,
  };
};

export const fetchClientAllProjects = (clientId) => {
  return (dispatch) => {
    dispatch(fetchClientProjectsForMilestonStart());
    axios
      .get(`api/v1/admin/client/project/${clientId}`)
      .then((res) => {
        // console.log(res);

        dispatch(fetchClientProjectsForMilestonSuccess(res.data.projects));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(
            fetchClientProjectsForMilestonFail(err.response.data.message)
          );
        } else {
          dispatch(fetchClientProjectsForMilestonFail("Something went wrong"));
        }
      });
  };
};
export const clearProjectMilestoneMsg = () => {
  return {
    type: actionTypes.CLEAR_MSG_PROJECT_MILESTONE,
  };
};
